var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import CardHeader from 'material-ui/Card/CardHeader';
var CustomCardHeader = /** @class */ (function (_super) {
    __extends(CustomCardHeader, _super);
    function CustomCardHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomCardHeader.prototype.render = function () {
        return (React.createElement(CardHeader, { title: React.createElement("span", { style: { color: '#008a71' } }, this.props.children) }));
    };
    return CustomCardHeader;
}(React.Component));
export { CustomCardHeader };



//////////////////
// WEBPACK FOOTER
// ./src/components/CustomCardHeader.tsx
// module id = 111
// module chunks = 0